export enum QuestionSetType {
  InitialAssessment,
  PreCourseAssessment,
  PostCourseAssessment,
}
